<template>
  <div class="left-column-banner" id="bx_3218110189_2622">
    <a :href="url" target="_blank">
      <v-img :src="img" width="250" height="250" />
    </a>
    <div class="sert-lb mt-8">
      <a href="/upload/certificates/certificate.pdf" target="_blank"
        >Сертификат на поставку материалов</a
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      default: "/images/banners/banner.jpeg",
    },
    url: {
      type: String,
      default: "/upload/certificates/certificate.pdf",
    },
  },
};
</script>

<style lang="scss" scoped></style>
